import { useEffect } from 'react';
import { getCompanyClients } from 'src/legacy/redux/slices/client';
import { getCustomerList } from 'src/legacy/redux/slices/customer';
import { getFosterFamilies } from 'src/legacy/redux/slices/fosterFamily';
import {
  getAgreementLegalBasisList,
  getPlacementCharacterList,
  getPlacementList,
  getPlacementPurposeList,
  getPlacementReasonList,
  getPlacementTypesList,
  getTerminationReasonList,
} from 'src/legacy/redux/slices/placement';
import { getCompanyUsers } from 'src/legacy/redux/slices/user';
import { useDispatch, useSelector } from 'src/legacy/redux/store';
import { useActiveCompany } from 'src/organization/hooks/useActiveCompany';

export const usePlacementData = () => {
  const dispatch = useDispatch();

  const { activeCompany } = useActiveCompany();
  const { companyClients } = useSelector((state) => state.client);
  const { customers } = useSelector((state) => state.customer);
  const { fosterFamilies } = useSelector((state) => state.fosterFamily);
  const { companyUsers } = useSelector((state) => state.user);
  const {
    agreementLegalBases,
    placementCharacters,
    placementPurposes,
    placementReasons,
    placements,
    placementTypes,
    terminationReasons,
  } = useSelector((state) => state.placement);

  useEffect(() => {
    if (activeCompany && !customers) {
      dispatch(getCustomerList(activeCompany.id, {}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, customers]);

  useEffect(() => {
    if (!companyClients && activeCompany) {
      dispatch(
        getCompanyClients({
          company: activeCompany.id,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyClients, activeCompany]);

  useEffect(() => {
    if (activeCompany && !fosterFamilies) {
      dispatch(
        getFosterFamilies({
          company: activeCompany.id,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, fosterFamilies]);

  useEffect(() => {
    if (!placements && activeCompany) {
      dispatch(getPlacementList({ company: activeCompany.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, placements]);

  useEffect(() => {
    if (!companyUsers && activeCompany) {
      dispatch(getCompanyUsers(activeCompany.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyUsers, activeCompany]);

  useEffect(() => {
    if (!agreementLegalBases) {
      dispatch(getAgreementLegalBasisList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agreementLegalBases]);

  useEffect(() => {
    if (!placementCharacters) {
      dispatch(getPlacementCharacterList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementCharacters]);

  useEffect(() => {
    if (!placementPurposes) {
      dispatch(getPlacementPurposeList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementPurposes]);

  useEffect(() => {
    if (!placementReasons) {
      dispatch(getPlacementReasonList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementPurposes]);

  useEffect(() => {
    if (!placementTypes && activeCompany) {
      dispatch(getPlacementTypesList(false, activeCompany.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementTypes]);

  useEffect(() => {
    if (!terminationReasons) {
      dispatch(getTerminationReasonList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [terminationReasons]);

  const initialize = () => {};

  return {
    initialize,
  };
};
